import React from 'react';

export const SanityioLogo = () => {
  return (
    <svg
      className="stack-icons"
      id="uuid-bc05f062-9c0b-4441-a580-2af4cb8028f2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
    >
      <g id="uuid-f7a85e1b-08c4-4685-88d3-37dfe8d2f6ac">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" />
      </g>
      <g id="uuid-fcd70b08-1b9a-46f6-90e6-f1f87dbd235d">
        <g>
          <polygon points="67.9 47.7 67.9 57.1 64.9 57.1 64.9 46.3 67.9 47.7" fill="#f37368" />
          <path
            d="M25.4,55.3l2.3,2,9.5-4.9-1-2.4-10.8,5.3Zm39.5-6l7.6-4-1.3-2.2-6.3,3.2v3Z"
            fill="#f7a199"
          />
          <path
            d="M43.4,47v10.1h-2.9v-14.3l2.9,4.3Zm-18,8.3l2.3,2,4.3-10.9-1.4-3.7-5.2,12.6Z"
            fill="#f37368"
          />
          <path
            d="M30.5,42.7h3l5.5,14.3h-3l-5.4-14.3Zm13.3,0l6.3,9.8v4.5l-9.6-14.3h3.3Zm11.8,0h3v14.3h-3v-14.3Zm9.3,2.6h-4.6v-2.6h10.7l1.5,2.6h-7.6Z"
            fill="#f04939"
          />
          <polyline points="81.3 51.6 81.3 57.1 78.4 57.1 78.4 51.6" fill="#f7a199" />
          <polygon points="83.4 42.7 78.4 51.6 81.3 51.6 86.5 42.7 83.4 42.7" fill="#f04939" />
          <polygon points="78.4 51.6 73.2 42.7 76.5 42.7 80 48.8 78.4 51.6" fill="#f37368" />
          <path
            d="M14.2,44.4c0,2,1.2,3.2,3.7,3.8l2.6,.6c2.3,.5,3.8,1.9,3.8,4,0,.9-.3,1.9-.9,2.6,0-2.2-1.1-3.3-3.8-4l-2.6-.6c-2.1-.5-3.7-1.6-3.7-3.9s.3-1.8,.8-2.5"
            fill="#f04939"
          />
          <polygon
            points="50.1 51.8 50.1 42.7 53 42.7 53 57.1 50.1 57.1 50.1 51.8"
            fill="#f37368"
          />
          <path
            d="M21.8,52.3c1.1,.7,1.6,1.7,1.6,3.2-.9,1.2-2.5,1.8-4.4,1.8-3.2,0-5.5-1.6-5.9-4.3h3.1c.4,1.3,1.4,1.8,2.9,1.8,1.7,0,2.8-.9,2.9-2.5m-7.6-7.9c.9-1.2,2.4-1.9,4.3-1.9,3.3,0,5.2,1.7,5.6,4.2h-3c-.3-1-1.1-1.7-2.6-1.7-1.6,0-2.7,.9-2.8,2.4-1.1-.6-1.6-1.8-1.6-3Z"
            fill="#f37368"
          />
        </g>
      </g>
    </svg>
  );
};
